import { render } from "./SettingsColourGroupsView.vue?vue&type=template&id=e18f0b46"
import script from "./SettingsColourGroupsView.vue?vue&type=script&lang=js"
export * from "./SettingsColourGroupsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__